webpackJsonp([1],[
/* 0 */,
/* 1 */
/*!********************************!*\
  !*** multi ./example/index.js ***!
  \********************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /Users/luyilin/github/source/vue-maskedinput/example/index.js */2);


/***/ }),
/* 2 */
/*!**************************!*\
  !*** ./example/index.js ***!
  \**************************/
/*! no exports provided */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(/*! ./App.vue */ 7);



new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/*!*************************!*\
  !*** ./example/App.vue ***!
  \*************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_luyilin_github_source_vue_maskedinput_node_modules_babel_preset_vue_app_dist_index_common_js_useBuiltIns_true_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/luyilin/github/source/vue-maskedinput/node_modules/babel-preset-vue-app/dist/index.common.js",{"useBuiltIns":true}]]}!../node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03684207_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-03684207","hasScoped":false,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue */ 13);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-03684207","scoped":false,"hasInlineConfig":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./App.vue */ 8)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 9)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_luyilin_github_source_vue_maskedinput_node_modules_babel_preset_vue_app_dist_index_common_js_useBuiltIns_true_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03684207_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-03684207","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./example/App.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */,
/* 10 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/luyilin/github/source/vue-maskedinput/node_modules/babel-preset-vue-app/dist/index.common.js",{"useBuiltIns":true}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./example/App.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src__ = __webpack_require__(/*! ../src */ 11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MaskedInput: __WEBPACK_IMPORTED_MODULE_0__src__["a" /* default */]
  },

  data: function data() {
    return {
      pattern: '1111 1111',
      cardNumber: '',
      dateTime: '',
      date: '',
      time: '20:00:00',
      phone: '',
      plate: '',
      escaped: '',
      leading: '',
      hyphen: '',
      pai: '',
      mix: '',
      rePattern: '',
      rawVal: '',
      hide: ''
    };
  }
});

/***/ }),
/* 11 */
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inputmask_core__ = __webpack_require__(/*! inputmask-core */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inputmask_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_inputmask_core__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var KEYCODE_Z = 90;
var KEYCODE_Y = 89;

function getSelection(el) {
  var start, end, rangeEl, clone;
  if (el.selectionStart !== undefined) {
    start = el.selectionStart;
    end = el.selectionEnd;
  } else {
    try {
      el.focus();
      rangeEl = el.createTextRange();
      clone = rangeEl.duplicate();

      rangeEl.moveToBookmark(document.selection.createRange().getBookmark());
      clone.setEndPoint('EndToStart', rangeEl);

      start = clone.text.length;
      end = start + rangeEl.text.length;
    } catch (e) {}
  }

  return { start: start, end: end };
}

function isUndo(e) {
  return (e.ctrlKey || e.metaKey) && e.keyCode === (e.shiftKey ? KEYCODE_Y : KEYCODE_Z);
}

function isRedo(e) {
  return (e.ctrlKey || e.metaKey) && e.keyCode === (e.shiftKey ? KEYCODE_Z : KEYCODE_Y);
}

function setSelection(el, selection) {
  var rangeEl;

  try {
    if (el.selectionStart !== undefined) {
      el.focus();
      el.setSelectionRange(selection.start, selection.end);
    } else {
      el.focus();
      rangeEl = el.createTextRange();
      rangeEl.collapse(true);
      rangeEl.moveStart('character', selection.start);
      rangeEl.moveEnd('character', selection.end - selection.start);
      rangeEl.select();
    }
  } catch (e) {}
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'masked-input',

  render: function render(h) {
    return h('input', {
      ref: 'input',
      domProps: {
        value: this.value
      },
      on: {
        change: this._change,
        keydown: this._keydown,
        keypress: this._keypress,
        paste: this._paste
      }
    });
  },


  props: {
    pattern: {
      type: String,
      required: true
    },
    value: {
      type: String
    },
    formatCharacters: {
      type: Object,
      default: function _default() {
        return {
          'w': {
            validate: function validate(char) {
              return (/\w/.test(char)
              );
            }
          },
          'W': {
            validate: function validate(char) {
              return (/\w/.test(char)
              );
            },
            transform: function transform(char) {
              return char.toUpperCase();
            }
          }
        };
      }
    },
    placeholder: {
      type: String
    },
    placeholderChar: {
      type: String
    },
    hideUnderline: {
      type: Boolean
    }
  },

  watch: {
    pattern: function pattern() {
      this.init();
    },
    value: function value(newValue) {
      if (this.mask) this.mask.setValue(newValue);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    init: function init() {
      var _this = this;

      var options = {
        pattern: this.pattern,
        value: this.value,
        formatCharacters: this.formatCharacters
      };
      if (this.placeholderChar) {
        options.placeholderChar = this.props.placeholderChar;
      }
      this.mask = new __WEBPACK_IMPORTED_MODULE_0_inputmask_core___default.a(options);
      this.$refs.input.placeholder = this.placeholder ? this.placeholder : this.hideUnderline ? '' : this.mask.emptyValue;

      if (this.$refs.input.value === '') {
        this.$emit('input', '', '');
      } else {
        [].concat(_toConsumableArray(this.$refs.input.value)).map(function (i) {
          if (_this.mask.input(i)) {
            _this.$refs.input.value = _this.mask.getValue();
            setTimeout(_this._updateInputSelection, 0);
          }
        });
      }
    },
    _change: function _change(e) {
      var maskValue = this.mask.getValue();
      if (this.$refs.input.value !== maskValue) {
        // Cut or delete operations will have shortened the value
        if (this.$refs.input.value.length < maskValue.length) {
          var sizeDiff = maskValue.length - this.$refs.input.value.length;
          this._updateMaskSelection();
          this.mask.selection.end = this.mask.selection.start + sizeDiff;
          this.mask.backspace();
        }
        this._updateValue(e);
      }
    },
    _keydown: function _keydown(e) {
      if (isUndo(e)) {
        e.preventDefault();
        if (this.mask.undo()) {
          this._updateValue(e);
        }
        return;
      } else if (isRedo(e)) {
        e.preventDefault();
        if (this.mask.redo()) {
          this._updateValue(e);
        }
        return;
      }

      if (e.key === 'Backspace') {
        e.preventDefault();
        this._updateMaskSelection();
        if (this.mask.backspace()) {
          this._updateValue(e);
        }
        if (this.$refs.input.value === '') {
          this.$emit('input', '', '');
        }
      }
    },
    _keypress: function _keypress(e) {
      if (e.metaKey || e.altKey || e.ctrlKey || e.key === 'Enter') return;
      e.preventDefault();
      this._updateMaskSelection();
      if (this.mask.input(e.key || e.data)) {
        this._updateValue(e);
      }
    },
    _paste: function _paste(e) {
      e.preventDefault();
      this._updateMaskSelection();
      if (this.mask.paste(e.clipboardData.getData('Text'))) {
        this._updateValue(e);
      }
    },
    _updateMaskSelection: function _updateMaskSelection() {
      this.mask.selection = getSelection(this.$refs.input);
    },
    _updateInputSelection: function _updateInputSelection() {
      setSelection(this.$refs.input, this.mask.selection);
    },
    _getDisplayValue: function _getDisplayValue() {
      var value = this.mask.getValue();
      return value === this.mask.emptyValue ? '' : value;
    },
    _updateValue: function _updateValue(e) {
      this.$refs.input.value = this._getDisplayValue();
      this.$emit('input', this.$refs.input.value, this.mask.getRawValue());
      this._updateInputSelection();
      if (this.change) {
        this.change(e);
      }
    }
  }
});

/***/ }),
/* 12 */,
/* 13 */
/*!**************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03684207","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/App.vue ***!
  \**************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"wrap"},[_c('a',{staticClass:"github-corner",attrs:{"href":"https://github.com/luyilin/vue-maskedinput","aria-label":"View source on Github"}},[_c('svg',{staticStyle:{"fill":"#5fa1d2","color":"#fff","position":"absolute","top":"0","border":"0","right":"0"},attrs:{"width":"80","height":"80","viewBox":"0 0 250 250","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M0,0 L115,115 L130,115 L142,142 L250,250 L250,0 Z"}}),_c('path',{staticClass:"octo-arm",staticStyle:{"transform-origin":"130px 106px"},attrs:{"d":"M128.3,109.0 C113.8,99.7 119.0,89.6 119.0,89.6 C122.0,82.7 120.5,78.6 120.5,78.6 C119.2,72.0 123.4,76.3 123.4,76.3 C127.3,80.9 125.5,87.3 125.5,87.3 C122.9,97.6 130.6,101.9 134.4,103.2","fill":"currentColor"}}),_c('path',{staticClass:"octo-body",attrs:{"d":"M115.0,115.0 C114.9,115.1 118.7,116.5 119.8,115.4 L133.7,101.6 C136.9,99.2 139.9,98.4 142.2,98.6 C133.8,88.0 127.5,74.4 143.8,58.0 C148.5,53.4 154.0,51.2 159.7,51.0 C160.3,49.4 163.2,43.6 171.4,40.1 C171.4,40.1 176.1,42.5 178.8,56.2 C183.1,58.6 187.2,61.8 190.9,65.4 C194.5,69.0 197.7,73.2 200.1,77.6 C213.8,80.2 216.3,84.9 216.3,84.9 C212.7,93.1 206.9,96.0 205.4,96.6 C205.1,102.4 203.0,107.8 198.3,112.5 C181.9,128.9 168.3,122.5 157.7,114.1 C157.9,116.9 156.7,120.9 152.7,124.9 L141.0,136.5 C139.8,137.7 141.6,141.9 141.8,141.8 Z","fill":"currentColor"}})])]),_vm._v(" "),_c('h1',[_vm._v("Vue masked input")]),_vm._v(" "),_c('h2',[_vm._v("A Vue component which creates a masked  <input/>")]),_vm._v(" "),_c('ul',[_c('li',[_c('label',[_vm._v("Card Number: ")]),_vm._v(" "),_c('masked-input',{attrs:{"pattern":"1111 1111 1111 1111"},model:{value:(_vm.cardNumber),callback:function ($$v) {_vm.cardNumber=$$v},expression:"cardNumber"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.cardNumber))])],1),_vm._v(" "),_c('li',[_c('label',[_vm._v("DateTime: ")]),_vm._v(" "),_c('masked-input',{attrs:{"pattern":"1111/11/11 11:11:11","placeholder":"yyyy/mm/dd hh:mm:ss"},model:{value:(_vm.dateTime),callback:function ($$v) {_vm.dateTime=$$v},expression:"dateTime"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.dateTime))])],1),_vm._v(" "),_c('li',[_c('label',[_vm._v("Date: ")]),_vm._v(" "),_c('masked-input',{attrs:{"pattern":"1111/11/11","placeholder":"yyyy/mm/dd"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.date))])],1),_vm._v(" "),_c('li',[_c('label',[_vm._v("Time: ")]),_vm._v(" "),_c('masked-input',{attrs:{"pattern":"11:11:11","placeholder":"hh:mm:ss"},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.time))])],1),_vm._v(" "),_c('li',[_c('label',[_vm._v("Phone: ")]),_vm._v(" "),_c('masked-input',{attrs:{"pattern":"111 1111 1111"},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.phone))])],1),_vm._v(" "),_c('li',[_c('label',[_vm._v("License Plate: ")]),_vm._v(" "),_c('masked-input',{attrs:{"pattern":"A 11111","placeholder":"A 11111"},model:{value:(_vm.plate),callback:function ($$v) {_vm.plate=$$v},expression:"plate"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.plate))])],1),_vm._v(" "),_c('li',[_c('label',[_vm._v("Escaped: ")]),_vm._v(" "),_c('masked-input',{attrs:{"pattern":"11 \\* 11"},model:{value:(_vm.escaped),callback:function ($$v) {_vm.escaped=$$v},expression:"escaped"}})],1),_vm._v(" "),_c('li',[_c('label',[_vm._v("Leading: ")]),_vm._v(" "),_c('masked-input',{attrs:{"pattern":"(1) 111 1111"},model:{value:(_vm.leading),callback:function ($$v) {_vm.leading=$$v},expression:"leading"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.leading))])],1),_vm._v(" "),_c('li',[_c('label',[_vm._v("Hyphen: ")]),_vm._v(" "),_c('masked-input',{attrs:{"pattern":"11\\-11"},model:{value:(_vm.hyphen),callback:function ($$v) {_vm.hyphen=$$v},expression:"hyphen"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.hyphen))])],1),_vm._v(" "),_c('li',[_c('label',[_vm._v("Decimal: ")]),_vm._v(" "),_c('masked-input',{attrs:{"pattern":"1\\.111111111","placeholder":"3.141592651"},model:{value:(_vm.pai),callback:function ($$v) {_vm.pai=$$v},expression:"pai"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.pai))])],1),_vm._v(" "),_c('li',[_c('label',[_vm._v("Mix: ")]),_vm._v(" "),_c('masked-input',{attrs:{"pattern":"ww-WW-11","placeholder":"ww-WW-11"},model:{value:(_vm.mix),callback:function ($$v) {_vm.mix=$$v},expression:"mix"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.mix))])],1),_vm._v(" "),_c('li',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.pattern),expression:"pattern"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.pattern=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Pattern: ")]),_vm._v(" "),_c('option',[_vm._v("1111 1111")]),_vm._v(" "),_c('option',[_vm._v("111 111")]),_vm._v(" "),_c('option',[_vm._v("11 11")])]),_vm._v(" "),_c('masked-input',{attrs:{"pattern":_vm.pattern},model:{value:(_vm.rePattern),callback:function ($$v) {_vm.rePattern=$$v},expression:"rePattern"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rePattern))])],1),_vm._v(" "),_c('li',[_c('label',[_vm._v("Raw Value: ")]),_vm._v(" "),_c('masked-input',{attrs:{"pattern":"\\$111"},on:{"input":function($event){_vm.rawVal = arguments[1]}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rawVal))])],1),_vm._v(" "),_c('li',[_c('label',[_vm._v("HideUnderline: ")]),_vm._v(" "),_c('masked-input',{attrs:{"pattern":"11 11","hideUnderline":true},model:{value:(_vm.hide),callback:function ($$v) {_vm.hide=$$v},expression:"hide"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.hide))])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[1]);


// WEBPACK FOOTER //
// client.ebdd2f5a.js